import React from 'react';
import { Button, useDataProvider, useNotify, useRecordContext, useRedirect } from 'react-admin';

interface CloneScoringButtonProp {
  record?: any;
  variant?: 'text' | 'outlined' | 'contained';
  style?: any;
}

const CloneScoringButton: React.FC<CloneScoringButtonProp> = () => {
  const record = useRecordContext();
  if (!record) { return null; }

  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const handleOnClick = (event: any) => {
    event.stopPropagation();

    dataProvider.getOne('scorings', { id: record.id })
      .then(({ data }) => {
        redirect('/scorings/create', undefined, undefined, undefined, data);
      })
      .catch((err) => {
        notify('Nao foi possivel realizar a operacao, tente novamente');
      });
  };

  return (
    <>
      <Button onClick={handleOnClick} variant='outlined' label="Clonar" />
    </>
  );
};

export default CloneScoringButton;
